import React from 'react';
import ReactMarkdown from 'react-markdown';
import remarkGfm from 'remark-gfm';
import remarkMath from 'remark-math';
import rehypeKatex from 'rehype-katex';
import 'katex/dist/katex.min.css';
import { rewriteProxyLink } from '../../utils/proxyUrls';

interface MarkdownPreviewProps {
  source: string;
  sessionId?: string;
  placeholder?: string;
  className?: string;
  onClick?: (e: React.MouseEvent) => void;
}

export const MarkdownPreview: React.FC<MarkdownPreviewProps> = ({
  source,
  sessionId,
  placeholder = 'Nothing to render',
  className = 'p-4 markdown-preview',
  onClick,
}) => {
  if (!source.trim()) {
    return (
      <div className={className} onClick={onClick}>
        <p className="text-gray-500 italic">{placeholder}</p>
      </div>
    );
  }

  return (
    <div className={className} onClick={onClick}>
      <ReactMarkdown
        remarkPlugins={[remarkGfm, remarkMath]}
        rehypePlugins={[rehypeKatex]}
        components={{
          a: ({ href, children, ...props }) => {
            const rewritten = sessionId && href ? rewriteProxyLink(href, sessionId) : null;
            return (
              <a
                href={rewritten || href}
                target={rewritten ? '_blank' : undefined}
                rel={rewritten ? 'noopener noreferrer' : undefined}
                {...props}
              >
                {children}
              </a>
            );
          },
        }}
      >
        {source}
      </ReactMarkdown>
    </div>
  );
};

export default MarkdownPreview;
